import cookie from 'webmd-cookie';
import debug from 'webmd-debug';
import { getEnv } from 'webmd-url';

/*
 * Medscape Exchange api integration
 */
if (typeof window !== 'undefined') {

	// Create webmd object if it doesn't already exist
	window.webmd = window.webmd || {};
	window.googletag = window.googletag || {};
	let MEADS = {
		serverUrls: {
			dev: 'dev.mdscpxchg.com',
			prod: 'serving.mdscpxchg.com'
		},
		serverProtocol: 'https',
		endpoint: '/ad',
		minOrd: 10000000,
		maxOrd: 99999999,
		externals: [],
		requestedExternals: [],
		npi: '',
		publisherID: 'webmd',
		biddingWinners: {},
		medscapePos: ['101','121','137','141','2025','2026','1923'],

		getOrd: function () {
			return Math.floor( Math.random() * this.maxOrd ) + this.minOrd;
		},

		getOrder:function() {
			let ord = ( typeof window.parent.s_pageview_id == "string" ? window.parent.s_pageview_id : this.getOrd() ) + "-" + this.getOrd();
			return ord;
		},

		getServer: function() {
			let env;
			let host = window.location && window.location.host ? window.location.host : '';
			if (host.includes('staging') || host.includes('qa') || host.includes('preview') || host.includes('devint')) {
				env = 'dev';
			}else{
				env = 'prod';
			}
			return this.serverProtocol + '://' + this.serverUrls[env];
		},

		parseCookie: function (str, delimeter) {
			var
				o,
				j,
				i,
				l,
				options = {};

			o = str.split(delimeter);
			l = o.length;

			for (i = 0; i < l; i++) {
				j = o[i].split('=');

				if (j[0]) {
					options[[j[0]]] = j[1] || '';
					options[[j[0]]] = options[[j[0]]].replace(/,\s+/g, ',');
				}
			}

			return options;
		},		

		getNPI: function() {
			// Added the condition to prevent cookie code execution before every ad call
			// Executes only before the first ad call
			let medat = cookie('medat');
			let cookieParts;
			if ( this.npi == '' ) {
				let authcookie = cookie('checked_pp');
				if ( authcookie && authcookie.indexOf('#') > -1 ) {
					let authCookieParts = authcookie.split('#');
					if( authCookieParts[1] ){
						this.npi = authCookieParts[1];
					}
				}else if (medat) {
					cookieParts = this.parseCookie(medat, '&');
					if(cookieParts && cookieParts.dt){
						this.npi =  cookieParts.dt;
					}
				}

			}
			return this.npi;
		},

		getAdPositions:function() {

			this.externals = [];
			/**
			 *  This method fetches the pos available on the page and push only
			 *  the display pos objects into the externals array.
			 *  Get the slots from googletag object and find id, sizes. Find the
			 *  pos value for the respective slot id from webmd.ads.ads.
			 *  Push the slot into externals if it is not available already in the
			 *  requestedExternals ( it has all the already requested pos values ).
			 *  externals hold only the current ad call pos value.
			 */
			let gptSlots = googletag.pubads().getSlots();
			let idList = this.requestedExternals.map(ad => ad.slotId);

			for (let i = 0; i < gptSlots.length; i++) {
				let ad = gptSlots[i];
				let slotId = ad.getSlotElementId();
				let adSlots = webmd.ads ? webmd.ads.ads : {};
				let posValue = adSlots[slotId] ? adSlots[slotId]['pos'].toString() : '';
				let idValue = adSlots[slotId] ? adSlots[slotId]['id'].toString() : '';

				if (posValue && idValue && this.medscapePos.includes(posValue) && !idList.includes(idValue) ) {
					let slot = {
						pos : posValue,
						id : `${this.publisherID}-${posValue}`,
						slotId : slotId,
						googleSlot : ad,
					};
					slot.sizes = ad.getSizes().map(function(size) {
						return size == 'fluid' ? [320,50] : Object.values(size);
					});
					this.externals.push(slot);
				}
			}

			return this.externals;
 	 	},

		getUrl: function () {
			let adPositions = this.getAdPositions();
			// List of pos value ids in already requested externals
			let oldIds = this.requestedExternals.map(ad => ad.id);
			// List of pos value ids in current externals object
			let currentIds = adPositions.map(ad => ad.id);
			// Return only the new pos ids that are not requested
			let newIds = currentIds.filter((id) => !oldIds.includes(id));
			// push the current externals to the requested externals
			this.requestedExternals.push(...this.externals);
			// Compare the length if any old pos is removed and set the slot targets for old pos value slots
			if (newIds.length != currentIds.length) {
				this.setOldSlotTargets();
			}
			if (newIds.length == 0) {
				return '';
			}
			// Remove duplicates in the new ids array
			newIds = [...new Set(newIds)];
			let ord = this.getOrder();
			let server = this.getServer();
			let npi = this.getNPI();
			if (npi && npi != '') {
			  return `${server}${this.endpoint}?external_ids=${newIds.join(',')}&npi_hashed=${npi}&ord=${ord}`;				
			} else {
				debug('Hashed NPI is empty to call Medscape-Exchange api');
				return '';
			}
		},

		setOldSlotTargets: function() {
			// set bidding targets for already requested old pos slots
			// and remove them from this.externals 
			let externals = [...this.externals];
			let biddingWinners = this.biddingWinners;
			let newExternals = [];
			this.externals = [];
			externals.forEach(function(slot) {
				let adSlot = slot.googleSlot;
				if ( biddingWinners[slot.pos] ) {
					let keyValueObj = biddingWinners[slot.pos];
					Object.keys(keyValueObj).forEach(function (medsKey) {
						adSlot.setTargeting(medsKey, keyValueObj[medsKey]);
					});
				} else {
					newExternals.push(slot);
				}
			})
			this.externals.push(...newExternals);
		},

		addMedExSlotLevelKeys: function() {
			let url = this.getUrl();
			if ( url == '' ) {
				return;
			}
			let winners = {};
			let losers = {}
			let externals = this.externals;
			let biddingWinners = this.biddingWinners;
			const npi = this.npi;
			if(!npi || npi == undefined) {
				debug("NPI is undefined for medscape exchange");
				window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-exchange", "webmd-medscape-exchange-no-npi");
				return;
			}
			var xhr = new XMLHttpRequest();
			xhr.open('GET', url);
			xhr.withCredentials = true;
			xhr.timeout = 800;
			xhr.send();
			xhr.onreadystatechange = function () {
				if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
					// Request finished. Do processing here.
					debug('MEDSCAPE EXCHANGE API WAS SUCCESS ' + this.responseText);

					let data;

					var url = document.location.href;
					if (url && url.indexOf('mexres=1') > -1 ) {
						data = {
							"ord": "170558385807711944-37150504",
							"winners": [
								{
									"impid": "5499ba8e-caea-4f56-a71a-800991641aad",
									"h": 90,
									"w": 728,
									"external_id": "webmd-141",
									"winner_id": "rtb_1_1",
									"price": 770,
									"deal_id": "MedEx008"
								}
							],
							"matched_data": [
								{
									"external_id": "webmd-101",
									"deal_ids": [
										"MedEx005",
										"MedEx006"
									]
								},
								{
									"external_id": "webmd-137",
									"deal_ids": [
										"MedEx005"
									]
								},
								{
									"external_id": "webmd-121",
									"deal_ids": [
										"MedEx005"
									]
								},	
								{
									"external_id": "webmd-2025",
									"deal_ids": [
										"MedEx005"
									]
								},
								{
									"external_id": "webmd-2026",
									"deal_ids": [
										"MedEx005"
									]
								},
								{
									"external_id": "webmd-1923",
									"deal_ids": [
										"MedEx005"
									]
								}
							]
						}
					} else {
						data = JSON.parse(this.responseText);
					}

					// Code enters the block when the response has bidding values or even empty array
					if (Object.keys(data).length > 0) {
						const ord = [ data.ord ];
						let win = data.winners;
						let matched_data = data.matched_data;
						let length = win.length;
						let mdataLen = matched_data.length;
						for (let i=0; i<length; i++ ) {
							let posID = win[i]['external_id'];
							let pos = posID.split('-')[1];
							win[i]['ord'] = ord;
							winners[pos] = win[i];
						}
						for (let i=0; i<mdataLen; i++ ) {
							let posID = matched_data[i]['external_id'];
							let pos = posID.split('-')[1];
							let deal_ids = matched_data[i]['deal_ids'];
							losers[pos] = deal_ids.toLocaleString();
						}

						externals.forEach((slot) => {

							let keyValueObj = {};
							let adSlot = slot.googleSlot;
							const winner = winners[slot.pos]; 

							if ( typeof winner == "object" ) {
								// This block executes if the bidding response for the pos is received
								const impid = [ winner.impid ];
								const moa = [ winner.winner_id ];
								const mop = [ winner.price ];
								const ord = winner.ord;
								const size = [ winner.w + 'x' + winner.h ];
								const dealId = [ winner.deal_id ];
								keyValueObj["rord"] = ord;
								keyValueObj["mcs"] = size;
								keyValueObj["imid"] = impid;
								keyValueObj["moa"] = moa;
								keyValueObj['deal_id'] = dealId;
								let id = slot.slotId;
								if (npi && npi != '') {
									keyValueObj['dt'] = npi;
								}
								
								if ( window.proclivityData && window.proclivityData[id] ) {
										let mePrice = mop;
										let pPrice,pdp;
										keyValueObj["mop"] = mop;
										pdp = window.proclivityData[id].pdp;
										pPrice = parseInt(pdp.split("_")[1]);
										keyValueObj["pdp"] = pdp;
										if (mePrice < pPrice) {
											keyValueObj["oaw"] = "proc";
										}else{
											keyValueObj["oaw"] = "me";
										}
								} else {
										let mePrice = mop;
										keyValueObj["mop"] = mop;
										let pPrice = 0;
										keyValueObj["pdp"] = "0";
										if (mePrice < pPrice) {
											keyValueObj["oaw"] = "proc";
										} else { 
											keyValueObj["oaw"] = "me";
										}
								}

							} else {
								// This block executes if the bidding response for the pos is not received
								if( losers[slot.pos] ) {
									keyValueObj['bid_ids'] = losers[slot.pos];
								}
							}

							biddingWinners[slot.pos] = keyValueObj;

							// setting slot level targets for the ad slots
							Object.keys(keyValueObj).forEach(function (key) {
								adSlot.setTargeting(key, keyValueObj[key]);
							});

						});
					}

				} else if (this.readyState == XMLHttpRequest.DONE && this.status != 200) {
					debug('MEDSCAPE CONNECTION FAILED: ' + this.responseText);
					window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-exchange", "webmd-medscape-exchange-connection-failed");
				}
			}
			xhr.ontimeout = function (e) {
				debug('MEDSCAPE API REQUEST TIMED OUT');
				window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medscape-exchange", "webmd-medscape-exchange-connection-timeout");
				debug(e);
			}

		}

	};

	window.tpsvc = window.tpsvc || {};
	// The ads code will execute every command inside this queue before an ad request is made
	window.tpsvc.cmds = window.tpsvc.cmds || [];
	// The ads code will wait for every promise in this queue to resolve before an ad request is made
	window.tpsvc.promises = window.tpsvc.promises || [];

	/**
	 * we need to load Medscape Exchange once __tcfapiPromise is resolved,
	 * the Promise is resolved once tcfapi.js is loaded onto the page
	 *
	 * tcfapi.js is loaded only in EU locations and in other locations the Promise is
	 * resolved immediately (handled in IAB stub code - webmd-ccm.js)
	 */
	Promise.resolve(window.__tcfapiPromise).then(function () {

		//PPE-379353 : Disable Vendor
		//Disable vendor if url containts vendor=0 or me=0
		var url = (document.referrer) ? document.referrer : document.location.href;
		if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('me=0') > -1)) {
		return false;
		}

		// block vendor on sensitive pages
		if (window.s_sensitive && window.s_sensitive === "true") {
		return false;
		}

		//PPE-411484 don't execute on member and webmdrx pages
		// if we are on member or webmdrx page, return immediately
		if ((/member.|webmdrx\./).test(location.host)) {
		return;
		}

		window.tpsvc.cmds.push(MEADS.addMedExSlotLevelKeys.bind(MEADS));

	});

};
